import { render, staticRenderFns } from "./SsvProvider.vue?vue&type=template&id=7c2be559&scoped=true&"
import script from "./SsvProvider.vue?vue&type=script&lang=js&"
export * from "./SsvProvider.vue?vue&type=script&lang=js&"
import style0 from "./SsvProvider.vue?vue&type=style&index=0&id=7c2be559&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2be559",
  null
  
)

export default component.exports